import { render, staticRenderFns } from "./uploading-image-to-server.vue?vue&type=template&id=78878084&"
import script from "./uploading-image-to-server.vue?vue&type=script&lang=ts&"
export * from "./uploading-image-to-server.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports